import React from "react";

/**
 * Simple setState closure
 * It receives a setState function returned by React.useState()
 *
 * When to use it?
 * When you have a simple change of state
 *
 * Why to use it?
 * It will help you with annoying code coverage where you are
 * doing a simple setState: forget istanbul statements
 *
 * @example
 * const [name, setName] = React.useState("");
 * <Input id="name" value={name} onChange={setState(setName)} />
 */
export function setState<T>(setState: React.Dispatch<React.SetStateAction<T>>) {
  return (value: T) => {
    setState(value);
  };
}
